import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import useWindowDimensions from 'shared/hooks/useWindowDimensions';
import { checkEmail } from 'shared/lib/authUtils';
import { logoutSession } from 'shared/lib/logoutSession';

/**
 * Props for the sidebar `UserInfo` block: identity, popover state, and the
 * change-password / logout actions.
 *
 * Extracted from `Sidebar.jsx` (SA-1862) so the Konfigurasi Klaim shell reuses
 * the same behaviour instead of carrying a second copy that can drift away from
 * it. Logic is unchanged from the original inline version.
 *
 * @returns {Object} spread straight onto <UserInfo />
 */
export const useSidebarUserInfo = () => {
  const { t } = useTranslation('common');
  const { isMobile } = useWindowDimensions();
  const popoverRef = useRef(null);
  const [isPopoverOpen, setPopoverOpen] = useState(false);

  const profileName = localStorage.getItem('name');
  const profileEmail = checkEmail();

  const handleTogglePopover = () => setPopoverOpen((prev) => !prev);

  const handleLogout = () => {
    logoutSession();
  };

  const handleChangePassword = () => {
    window.location.href = '/change-password/send-reset-link';
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        setPopoverOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return {
    isMobile,
    isPopoverOpen,
    handleTogglePopover,
    handleChangePassword,
    handleLogout,
    profileName,
    profileEmail,
    popoverRef,
    t,
  };
};
